import { render, staticRenderFns } from "./WarehouseScreenWarehouses.vue?vue&type=template&id=cc32421a"
import script from "./WarehouseScreenWarehouses.vue?vue&type=script&lang=js"
export * from "./WarehouseScreenWarehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports